import React from 'react';
import BookingConfigurator from '../../components/BookingConfigurator/BookingConfigurator';
import './Quote.css';

const Quote = (props) => {
    return (
        <div className="quote-page-container">
            <BookingConfigurator
                {...props}
                isQuotePage={true}
                onSubmitQuote={props.handleSubmit}
            />
        </div>
    );
};

export default Quote;
